


















































import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import { format } from 'quasar'
import store from 'src/assets/store'
import Timer from 'components/Timer.vue'
import DeadlineTimer from 'components/DeadlineTimer.vue'
import ModalDialog from 'components/modals/Dialog.vue'
import { Session } from 'src/graphql/types'

@Component({
  components: {
    Timer,
    DeadlineTimer,
    ModalDialog
  }
})
export default class SessionManagerButtonClose extends Vue {
  pad = format.pad
  now = store.now

  @Prop()
  readonly session!: Session

  @Ref()
  readonly dialog!: ModalDialog

  async stop () {
    try {
      this.$emit('save', { stoppedAt: new Date() })
    } catch (e) {}
    this.close()
  }

  close () {
    this.dialog && this.dialog.hide()
    this.$router.replace('/presenter/' + this.session.topic?.id + '/sessions/')
  }
}
